<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003605.installation.dosage.titre' | translate"
      [description]="'P0003605.installation.dosage.description' | translate"
    >
    </app-header-configuration>

    @if (currentForm) {
      <form [formGroup]="currentForm">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <app-information-title
                [title]="'P0003605.installation.bassin' | translate"
                [information]="P0003605EnSavoirPlusDosage"
              ></app-information-title>

              <div class="position-relative">
                <ion-input
                  [placeholder]="
                    'P0003605.installation.bassin.volume' | translate
                  "
                  formControlName="volume"
                  mode="ios"
                  (ionBlur)="onVolumeBlur($event)"
                ></ion-input>
              </div>

              <app-label-description
                [description]="
                  'P0003605.installation.bassin.description' | translate
                "
              ></app-label-description>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <app-information-title
                [title]="'P0003605.installation.pompe' | translate"
                [information]="P0003605EnSavoirPlusDosage"
              ></app-information-title>

              <div class="position-relative">
                <ion-input
                  [placeholder]="
                    'P0003605.installation.pompe.debit' | translate
                  "
                  formControlName="debit"
                  mode="ios"
                  (ionBlur)="onDebitBlur($event)"
                ></ion-input>

                <div
                  class="d-inline-block position-absolute top-0 bottom-0 end-0 px-2"
                >
                  <div class="row h-100 align-items-center">
                    <div class="col text-center">
                      <span class="color-primary">(2.4l/h)</span>
                    </div>
                  </div>
                </div>
              </div>

              <app-label-description
                [description]="
                  'P0003605.installation.pompe.description' | translate
                "
              ></app-label-description>
            </div>
          </div>
        </div>
      </form>
    }

    <app-information-title
      [title]="'P0003605.installation.config.position' | translate"
    ></app-information-title>

    <app-larged-link
      [name]="'P0003605.installation.config.position.title' | translate"
      [textBeforeArrow]="
        P0003605PositionTypeEnum[currentForm!.controls['position']?.value ?? 0]
          .label | translate
      "
      (onPress)="openModal()"
    >
    </app-larged-link>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button
        color="primary"
        expand="block"
        (click)="onSubmit()"
        [disabled]="!currentForm?.valid"
      >
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
